import type { ReactNode } from 'react';

import { Button } from './Button';
import { Sheet } from './Sheet';

interface FilterSheetProps {
  open: boolean;
  onClose: () => void;
  onReset: () => void;
  /** Сколько записей проходит фильтр — на кнопке «Показать». */
  resultCount: number;
  children: ReactNode;
}

/**
 * Шторка фильтров: условия применяются сразу, а кнопка внизу говорит, сколько
 * записей останется. Подбирать фильтр вслепую и узнавать о пустом результате
 * после закрытия — лишний круг.
 */
export function FilterSheet({ open, onClose, onReset, resultCount, children }: FilterSheetProps) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      title="Фильтры"
      footer={
        <div className="flex gap-2">
          <Button variant="secondary" onClick={onReset}>
            Сбросить
          </Button>
          <Button block onClick={onClose}>
            {`Показать ${resultCount}`}
          </Button>
        </div>
      }
    >
      <div className="space-y-5 pb-2">{children}</div>
    </Sheet>
  );
}
